import { AxiosInstance, AxiosResponse } from 'axios';
import { BillingPortalSessionCreateDto } from './inputs/billing-portal-session-create.input';
import { BillingPortalSessionCreateResponse } from './responses/billing-portal-session-create.response';
import { CustomerSessionCreateResponse } from './responses/customer-session-create.response';
import { SubscriptionRefreshRolesResponse } from './responses/subscription-refresh-roles.response';

export class StripeModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async createCustomerSession(): Promise<AxiosResponse<CustomerSessionCreateResponse>> {
    return await this.client.post('/stripe/customer-sessions');
  }

  async createBillingPortalSession(
    dto: BillingPortalSessionCreateDto,
  ): Promise<AxiosResponse<BillingPortalSessionCreateResponse>> {
    return await this.client.post('/stripe/biling-portal/sessions', dto);
  }

  async refreshSubscriptionRoles(): Promise<AxiosResponse<SubscriptionRefreshRolesResponse>> {
    return await this.client.get('/stripe/subscriptions/refresh-roles');
  }
}
